import { gql } from "@apollo/client";

export const DeleteInstalledBaseIotReportSubscription = gql`
    mutation DeleteInstalledBaseIotReportSubscription ($id: ID!) {
        deleteInstalledBaseIotReportSubscription(id: $id) {
            success
            message
        }
    }
`;
